import { useQuery } from '@tanstack/react-query';
import { getQuoteHistory } from '../requests';
import { CACHE_TIME_5_MINUTES } from '@/shared/config';
import type { QuoteHistoryPeriod } from '@/shared/types';

interface UseQuoteHistoryOptions {
  asset: string;
  baseAsset: string;
  period: QuoteHistoryPeriod;
  enabled?: boolean;
}

export function useQuoteHistory({
  asset,
  baseAsset,
  period,
  enabled = true,
}: UseQuoteHistoryOptions) {
  const isSelfPair = asset === baseAsset;

  const query = useQuery({
    queryKey: ['quote-history', asset, baseAsset, period],
    queryFn: async () => {
      return await getQuoteHistory({ asset, baseAsset, period });
    },
    enabled: enabled && !!asset && !!baseAsset && !isSelfPair,
    staleTime: CACHE_TIME_5_MINUTES,
    gcTime: CACHE_TIME_5_MINUTES,
  });

  return {
    points: query.data?.points ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
